<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>The Era 1947-1957</h1>
</div>
</div>
<div>
<div class="figure">
</div>
<p class="center">
</p>
</div>
<h3 class="triple" style="text-align: center;">
	When the Yankees, the Giants, and the Dodgers Ruled the World</h3>
<h5 style="text-align: center;">
<br/>
<br/>
	by Roger Kahn</h5>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b5bc46a0